import { render, staticRenderFns } from "./edit_report.vue?vue&type=template&id=5142f28d&scoped=true"
import script from "./edit_report.vue?vue&type=script&lang=js"
export * from "./edit_report.vue?vue&type=script&lang=js"
import style0 from "./edit_report.vue?vue&type=style&index=0&id=5142f28d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5142f28d",
  null
  
)

export default component.exports